import { render, staticRenderFns } from "./ObiFloatingInput.vue?vue&type=template&id=61d39310&scoped=true&"
import script from "./ObiFloatingInput.vue?vue&type=script&lang=js&"
export * from "./ObiFloatingInput.vue?vue&type=script&lang=js&"
import style0 from "./ObiFloatingInput.vue?vue&type=style&index=0&id=61d39310&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d39310",
  null
  
)

export default component.exports